const currentHost = window.location.hostname;
const tenantConfig = window.__APP_CONFIG__?.TENANTS?.[currentHost] ?? {};

// "||" (not "??") on purpose: ops convention for this app family is to set an
// override to "" to mean "no override, use the next fallback tier" (see the
// live o4f-backoffice config.js, which does exactly that per-tenant). "??"
// would treat "" as a real value and stop there instead of falling through.
const config = {
  // Not tenant-specific: one backend serves every tenant hostname.
  apiBaseUrl:
    window.__APP_CONFIG__?.API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL,

  websiteId:
    tenantConfig.WEBSITE_ID ||
    window.__APP_CONFIG__?.WEBSITE_ID ||
    process.env.REACT_APP_WEBSITE_ID ||
    "KiltieWaSite",

  logoUrl:
    tenantConfig.LOGO_URL ||
    window.__APP_CONFIG__?.LOGO_URL ||
    process.env.REACT_APP_LOGO_URL ||
    "/assets/img/logo/logo.png",

  loginIllustrationUrl:
    tenantConfig.LOGIN_ILLUSTRATION_URL ||
    window.__APP_CONFIG__?.LOGIN_ILLUSTRATION_URL ||
    process.env.REACT_APP_LOGIN_ILLUSTRATION_URL ||
    "/assets/img/login_bg1.png",
};

export default config;
